<div class="sidebar">
    <app-sidebar-header [title]="'bookingDetails.label.fareConditions' | ibeadmin:'sync'"></app-sidebar-header>

    <div class="sidebar__body sl--scrollable low-contrast sidebar-size" #sidebar__body *ngIf="!flight">
        {{ 'bookingDetails.sidebars.fareConditions.text.flightNotFound' | ibeadmin:'sync'}}
    </div>

    <div class="sidebar__body sl--scrollable low-contrast sidebar-size" #sidebar__body *ngIf="flight">
        <article class="ticket vertical flight-card">
            <div class="top">
                <div>
                    <strong>{{ INDRA_printFlightDate() }}</strong>
                    <span> &mdash; </span>
                    <span aria-hidden="true">{{ 'bookingDetails.label.in' | ibeadmin | async }} </span>
                    <span class="flight-eta" *ngIf="INDRA_getTimeUnitKey(INDRA_getTimeTo()) !== 'bookingDetails.label.now'">
						{{ INDRA_printTimeTo }}
					</span>
                    <span class="flight-eta">
						{{ INDRA_getTimeUnitKey(INDRA_getTimeTo()) | ibeadmin | async }}
					</span>
                    <!-- <span class="flight-eta">in {{INDRA_printTimeTo}}</span> -->
                </div>
                <app-flight-details [flight]="INDRA_getFlightDetails()" [changeMode]="change" [index]="flightIndex"></app-flight-details>
            </div>
            <div class="tear-here">
                <div class="left"></div>
                <div class="divider-dashed"></div>
                <div class="right"></div>
            </div>
            <div class="bottom condensed">
                <app-svg [ngClass]="['brand--'+INDRA_getBrand()]" svg="sprite.svg#brand--{{INDRA_getBrand()}}" [alt]="INDRA_getBrand() + ' logo'">
                </app-svg>
            </div>
        </article>
        <div class="conditions-summary">
            <div class="conditions-summary--group">
                <div class="conditions-summary--label title-h6">
                    {{ 'bookingDetails.sidebars.fareConditions.title.cabin' | ibeadmin:'sync'}}
                </div>
                <div class="conditions-summary--value">
                    <div class="conditions-summary--text">
                        {{ (upgrade || change ? selectedBrand.cabin : flight.cabin) | titlecase }}
                    </div>
                    <!-- <div *ngIf="INDRA_isPNRFlightsMixed();" class="conditions-summary--subtext">
							{{ 'bookingDetails.sidebars.fareConditions.label.isMixedMessage' | ibeadmin:'sync'}}
					</div> -->
                </div>
            </div>
            <div *ngIf="INDRA_isPNRFlightsMixed();" class="conditions-summary--group">
                <div class="conditions-summary--label title-h6"></div>
                <div class="conditions-summary--value">
                    <div class="conditions-summary--text"></div>
                    <div class="conditions-summary--subtext">
                        {{ 'bookingDetails.sidebars.fareConditions.label.isMixedMessage' | ibeadmin:'sync'}}
                    </div>
                </div>
            </div>
            <div *ngIf="INDRA_isPNRFlightsMixed();" class="conditions-summary--group">
                <div class="conditions-summary--value">
                    <div class="conditions-summary--text">
                    </div>
                    <div class="conditions-summary--subtext">
                    </div>
                </div>
            </div>
            <div class="conditions-summary--group" *ngIf="changeItems.key && INDRA_getBrand()">
                <div class="conditions-summary--label title-h6">
                    {{ 'bookingDetails.sidebars.fareConditions.title.changes' | ibeadmin:'sync'}}
                </div>
                <div class="conditions-summary--value">
                    {{ 'bookingDetails.sidebars.fareConditions.changes.' + changeItems.key | ibeadmin:'sync'}}{{ changeItems.key === 'FEE' ? ':' : '' }} {{ changeItems.value }} {{ changeItems.currency }}
                    <ng-container *ngIf="noShow === 'FEE'">
                        <br> {{ 'bookingDetails.sidebars.fareConditions.changes.noshow1' | ibeadmin:'sync'}} {{ amount }} {{ 'bookingDetails.sidebars.fareConditions.changes.noshow2' | ibeadmin:'sync'}}
                    </ng-container>
                    <ng-container *ngIf="noShow === 'FREE'">
                        <br> {{ 'bookingDetails.sidebars.fareConditions.changes.noshow3' | ibeadmin:'sync'}}
                    </ng-container>
                </div>
            </div>
            <div class="conditions-summary--group" *ngIf="refundItems.key && INDRA_getBrand()">
                <div class="conditions-summary--label title-h6">
                    {{ 'bookingDetails.sidebars.fareConditions.title.cancellation' | ibeadmin:'sync'}}
                </div>
                <div class="conditions-summary--value">
                    <div class="conditions-summary--text">
                        {{ 'bookingDetails.sidebars.fareConditions.refunds.' + refundItems.key | ibeadmin:'sync'}}{{ refundItems.key === 'FEE' ? ':' : '' }} {{ refundItems.value }} {{ refundItems.currency }}
                    </div>
                    <!-- <div class="conditions-summary--subtext">{{ this.BRAND_INFO[INDRA_getBrand()].cancellation[1] }}</div> -->
                </div>
            </div>
        </div>
        <div class="conditions-details">
            <div class="conditions-details-group" *ngFor="let section of this.SECTIONS">
                <div (click)="INDRA_handleToggle(section)">
                    <h2 class="title title-h4">{{ section.label }}</h2>
                    <app-svg class="expand-icon" [ngClass]="['toggle-expand', section.state]" [attr.aria-expanded]="section.state && section.state === 'expanded' ? true : false" svg="icons.svg#general--arrow--bottom" [alt]="'Arrow icon'">
                    </app-svg>
                </div>
                <app-expand-collapse [state]="section.state">
                    <div>
                        {{section.description}}
                    </div>
                    <ul class="unordered-list">
                        <li *ngFor="let bullet of section.characteristics">{{bullet}}</li>
                    </ul>
                </app-expand-collapse>
            </div>
        </div>
        <div class="sidebar-flight-text">
            <p>
                <a class="link extras-feature__link" aria-label="Close dialog" (click)="INDRA_handleClose()" href="javascript:;" role="button">
					{{ 'editSidebar.text.closeThisWindow' | ibeadmin | async }}
				</a>
            </p>
        </div>
    </div>
</div>